import {XauditModel} from '../../../models/xaudit.model';
import {TreatmentPlanningProcedurePseudoModel} from './treatment-planning-procedure-pseudo.model';
import {TreatmentPlanningIssuesDataModel} from './treatment-planning-issues-data.model';

export class TreatmentPlanningDataModel extends XauditModel {
  CaseWorkItemFormsId: string;
  ParentDescription: string;
  Description: string;
  DoctorID: string;
  ParentTreatmentPlanningID: string;
  PatientId: string;
  ResultingPatientCaseId: string;
  TreatmentPlanningID: string;
  // TODO: In the backend dataTreatmentPlanning1 is an ICollection, but dataTreatmentPlanning2 is not???
  dataTreatmentPlanning1: TreatmentPlanningDataModel[];
  dataTreatmentPlanning2: TreatmentPlanningDataModel;
  dataTreatmentPlanningIssues: TreatmentPlanningIssuesDataModel[];
  enumTreatmentTypeID: string;

  isMedHistSigAndRev: boolean;
  dateMedHistSigAndRev: string;
  isPainHistSigAndRev: boolean;
  datePainHistSigAndRev: string;
  isConsentFormSigAndRev: boolean;
  dateConsentFormSigAndRev: string;
  isPreMedsVerified: boolean;
  datePreMedsVerified: string;
  isVialSignsTaken: boolean;
  dateVialSignsTaken: string;
  isPerioProbTaken: boolean;
  datePerioProbTaken: string;

  MTEID: string;

  // This is not in the reflected model on the backend, but rather an anonymous object created at execution time.
  Procedures: TreatmentPlanningProcedurePseudoModel[];
  enumTreatmentPlanStatusID: string;
  isApprovalPending:boolean;
  isApproved:boolean;
}

export  class PrintTreatmentPlanningModel
{
  PatientID: string;
  EnterpriseID: string;
  LOCID: string;
  ReportId: string;
  TreatmentPlanningId: string;
  TDOCID: string;
}
